import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-input-array-group',
  templateUrl: './input-array-group.component.html',
  styleUrls: ['./input-array-group.component.scss']
})
export class InputArrayGroupComponent implements OnInit {

  @Input()
  sectionsLength: number;

  @Input()
  groupName: string;

  @Input()
  groupSize: number;

  @Output()
  groupSizeChange = new EventEmitter<number>();

  @Input()
  max: number;

  constructor() { }

  ngOnInit(): void { }

  addGroup(): void {
    this.groupSize += 1;
    this.groupSizeChange.emit(this.groupSize);
  }

  removeGroup(): void {
    if (this.groupSize === 0) {
      return;
    }
    this.groupSize -= 1;
    this.groupSizeChange.emit(this.groupSize);
  }

}
